module.exports = __webpack_public_path__ + "static/media/ImportarLogo.1b347073.svg";